// Service-worker registration + native-shell helpers.
// Imported once from index.js. No-ops on non-PWA-capable browsers.

import { isNativeApp } from './native';

const SW_URL = '/service-worker.js';

export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  // Don't enable the SW inside Emergent's visual-edit iframe.
  if (window.self !== window.top) return;
  // The native app loads the live site; a cached shell would hide new deploys.
  // Also drop any worker an older app build registered.
  if (isNativeApp()) {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_URL).then((reg) => {
      // Auto-take-over when a new version is waiting.
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            // A new SW is waiting — let it activate immediately.
            installing.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    }).catch(() => { /* swallow registration errors silently */ });
  });
}

/**
 * Capture the beforeinstallprompt event so InstallAppBanner.jsx can fire it
 * on its own button-click. Without this, browsers (esp. Chrome on Android)
 * choose when to surface their default banner, which is not always optimal.
 */
let deferredInstallPrompt = null;
export function listenForInstallPrompt() {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
    window.dispatchEvent(new CustomEvent('fz-install-available'));
  });
  window.addEventListener('appinstalled', () => {
    deferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent('fz-installed'));
  });
}
export function getDeferredInstallPrompt() { return deferredInstallPrompt; }
export function clearDeferredInstallPrompt() { deferredInstallPrompt = null; }

export { isNativeApp };
